class GameContainer {
    element = document.querySelector('#game-container') as HTMLDivElement

    constructor() {
        // this.element.style.setProperty('opacity', '0')
        // prevent right click context menu
        this.element.oncontextmenu = (ev) => {
            ev.preventDefault()
            ev.stopPropagation()
            return false
        }
    }

    setMouseIdle = (isIdle: boolean) => {
        isIdle ? this.element.classList.add('mouse-idle') : this.element.classList.remove('mouse-idle')
    }

    show = () => {
        this.element.classList.remove('hidden')
        this.element.animate(
            [
                {
                    // from
                    opacity: 0,
                },
                {
                    // to
                    opacity: 1,
                },
            ],
            { duration: 200 }
        )
    }

    hide = () => {
        this.element.classList.add('hidden')
    }
}

export default new GameContainer()
